module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 290
// module chunks = 10 11 12 13 14 15 16 17 18